var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BehaviorSubject } from 'rxjs';
import { ApiService } from '../api/api.service';
import { GetCartId$Request, GetCartId$Response, CreateShopcart$Request, CreateShopcart$Response, GetShopcart$Request, GetShopcart$Response, AddCartItem$Request, AddCartItem$Response, RemoveCartItem$Request, RemoveCartItem$Response, SubmitCart$Request, SubmitCart$Response, RemoveShopcart$Request, RemoveShopcart$Response } from '@api/types';
import { tap } from 'rxjs/operators';
var ShopcartService = /** @class */ (function () {
    function ShopcartService(api) {
        this.api = api;
        this.defaultState = {
            provider: null,
            shopcartItemList: [],
            submittedAt: null,
            url: null
        };
        this.defaultCartIdState = {
            cartId: null
        };
        this.cartIdState = this.defaultCartIdState;
        this.state = this.defaultState;
        this.cartIdSubject = new BehaviorSubject(this.cartIdState);
        this.shopcartSubject = new BehaviorSubject(this.state);
    }
    ShopcartService.prototype.setCartIdState = function (newState) {
        if (this.cartIdState.cartId === newState.cartId) {
            return;
        }
        this.cartIdState = newState;
        this.cartIdSubject.next(this.cartIdState);
    };
    ShopcartService.prototype.getCartIdState = function () {
        return this.cartIdSubject;
    };
    ShopcartService.prototype.setState = function (newState) {
        this.state = __assign({}, this.state, newState);
        this.shopcartSubject.next(this.state);
    };
    ShopcartService.prototype.getState = function () {
        return this.shopcartSubject;
    };
    ShopcartService.prototype.getCartId = function (request, forceFetch) {
        if (forceFetch === void 0) { forceFetch = false; }
        if (forceFetch || !this.cartIdState.cartId) {
            if (!this.cartIdIsLoading) {
                this.getCartIdLatest(request).subscribe();
            }
        }
        return this.cartIdSubject;
    };
    ShopcartService.prototype.getCartIdLatest = function (request) {
        var _this = this;
        this.cartIdIsLoading = true;
        return this.api.shopcart.getCartId(request).pipe(tap(function (cartId) { return _this.setCartIdState(cartId); }), tap(function (_a) {
            var cartId = _a.cartId;
            if (cartId) {
                _this.getShopcartLatest({ cartId: cartId }).subscribe();
            }
        }), tap(function () { return (_this.cartIdIsLoading = false); }));
    };
    ShopcartService.prototype.createShopCart = function (request) {
        var _this = this;
        return this.api.shopcart
            .createShopcart(request)
            .pipe(tap(function (cartId) { return _this.setCartIdState(cartId); }));
    };
    ShopcartService.prototype.getShopcart = function (request, forceFetch) {
        if (forceFetch === void 0) { forceFetch = false; }
        if (forceFetch || !this.cartIdState.cartId) {
            if (!this.isLoading) {
                this.getShopcartLatest(request).subscribe();
            }
        }
        return this.shopcartSubject;
    };
    ShopcartService.prototype.getShopcartLatest = function (request) {
        var _this = this;
        this.isLoading = true;
        return this.api.shopcart.getShopcart(request).pipe(tap(function (shopcart) { return _this.setState(shopcart); }), tap(function () { return (_this.isLoading = false); }));
    };
    ShopcartService.prototype.addCartItem = function (request) {
        var _this = this;
        return this.api.shopcart
            .addCartItem(request)
            .pipe(tap(function (shopcart) { return _this.setState(shopcart); }));
    };
    ShopcartService.prototype.removeCartItem = function (request) {
        var _this = this;
        return this.api.shopcart
            .removeCartItem(request)
            .pipe(tap(function (shopcart) { return _this.setState(shopcart); }));
    };
    ShopcartService.prototype.submitCart = function (request) {
        var _this = this;
        return this.api.shopcart
            .submitCart(request)
            .pipe(tap(function (shopcart) { return _this.setState(shopcart); }));
    };
    ShopcartService.prototype.removeShopcart = function (request) {
        this.resetState();
        return this.api.shopcart.removeShopcart(request);
    };
    ShopcartService.prototype.resetState = function () {
        this.setCartIdState(this.defaultCartIdState);
        this.setState(this.defaultState);
    };
    return ShopcartService;
}());
export { ShopcartService };
